import { baseRoute } from '../../../../constants/routes';

export const IMAGE_ANSWERS_ROUTE = baseRoute + '/image-answers';